//import Vue from 'vue'
//import Router from 'vue-router'
import store from '@/store'
import Util from '../assets/js/util.js'
import setTitle from '@/router/setTitle.js';


// auth group
const Oauth = () => import(/* webpackChunkName: "auth" */  '@/components/Oauth')
const OauthThirdpart = () => import(/* webpackChunkName: "auth" */  '@/components/OauthThirdpart')
const Strobe = () => import(/* webpackChunkName: "auth" */  '@/components/Strobe')
// house group
const Home = () => import(/* webpackChunkName: "house" */  '@/components/Home')
const followHaAdd  = () => import(/* webpackChunkName: "house" */  '@/components/ha/followHaAdd')
const followHa  = () => import(/* webpackChunkName: "house" */  '@/components/ha/followHa')
const MyHouse = () => import(/* webpackChunkName: "house" */  '@/components/MyHouse')
const testgeo = () => import(/* webpackChunkName: "house" */  '@/components/testgeo')
const HouseDetail = () => import(/* webpackChunkName: "house" */  '@/components/HouseDetail')
const HouseAdd = () => import(/* webpackChunkName: "house" */  '@/components/HouseAdd')
const HouseEvaluate = () => import(/* webpackChunkName: "house" */  '@/components/HouseEvaluate')
const ObjectionList = () => import(/* webpackChunkName: "house" */  '@/components/objectionList')
const SetAlarm = () => import(/* webpackChunkName: "house" */  '@/components/SetAlarm')
const AssessRecord = () => import(/* webpackChunkName: "house" */  '@/components/AssessRecord')
const AssessHistory = () => import(/* webpackChunkName: "house" */  '@/components/AssessHistory')
const HouseMap = () => import(/* webpackChunkName: "house" */  '@/components/MapSelect')
const Maps = () => import(/* webpackChunkName: "house" */  '@/components/Maps')

// ha group
const Ha = () => import(/* webpackChunkName: "ha" */  '@/components/ha/index')
const HaDetail = () => import(/* webpackChunkName: "ha" */  '@/components/ha/detail')
const HaSupport = () => import(/* webpackChunkName: "ha" */  '@/components/ha/support')
const addHaInfo = () => import(/* webpackChunkName: "ha" */  '@/components/ha/addHaInfo')
const HaAround = () => import(/* webpackChunkName: "ha" */  '@/components/ha/around')
const MapAsset  = () => import(/* webpackChunkName: "ha" */  '@/components/map/asset')
const MapAsset2  = () => import(/* webpackChunkName: "ha" */  '@/components/map2/asset')


// pig group
const coSolution = () => import(/* webpackChunkName: "pig" */  '@/components/ad/coSolution')
const pighouseShow = () => import(/* webpackChunkName: "pig" */  '@/components/ad/pighouseShow')
const pighouseAdd = () => import(/* webpackChunkName: "pig" */  '@/components/ad/pighouseAdd')
const pighouseResult = () => import(/* webpackChunkName: "pig" */  '@/components/ad/pighouseResult')

// trade group
const tradeList = () => import(/* webpackChunkName: "trade" */  '@/components/trade/list')
const tradeDetail = () => import(/* webpackChunkName: "trade" */  '@/components/trade/detail')
const selectHouse = () => import(/* webpackChunkName: "trade" */  '@/components/selectHouse/list')
const selectHouseShopOffice = () => import(/* webpackChunkName: "trade" */  '@/components/selectHouse/listshop')
const apartment = () => import(/* webpackChunkName: "trade" */  '@/components/selectHouse/apartment')
const tradeComunity = () => import(/* webpackChunkName: "trade" */  '@/components/trade/comunity')
const tradeApartment = () => import(/* webpackChunkName: "trade" */  '@/components/trade/apartment')
const tradeReport = () => import(/* webpackChunkName: "trade" */  '@/components/trade/report')

// release group
const release = () => import(/* webpackChunkName: "release" */   '@/components/release/index')
const editRelease = () => import(/* webpackChunkName: "release" */   '@/components/release/edit')
const livingIndex = () => import(/* webpackChunkName: "release" */   '@/components/livingIndex/home')

// loan group
const loanApply = () => import(/* webpackChunkName: "loan" */ '@/components/loan/apply')
const creditRegistry = () => import(/* webpackChunkName: "loan" */ '@/components/loan/creditRegistry')
const loanStatus = () => import(/* webpackChunkName: "loan" */ '@/components/loan/loanStatus')

// 个人中心
const Manage = () => import(/* webpackChunkName: "manage" */  '@/components/manage/index')
const Account = () => import(/* webpackChunkName: "manage" */  '@/components/manage/account')
const protocol = () => import(/* webpackChunkName: "manage" */  '@/components/manage/protocol')
const ManageInfo = () => import(/* webpackChunkName: "manage" */  '@/components/manage/info')
const ManageHa = () => import(/* webpackChunkName: "manage" */  '@/components/manage/ha')
const ManageHouse = () => import(/* webpackChunkName: "manage" */  '@/components/manage/house')

// about group
const Job = () => import(/* webpackChunkName: "about" */  '@/components/about/Job')
const toPage = () => import(/* webpackChunkName: "about" */  '@/components/toPage')
const toBankhome = () => import(/* webpackChunkName: "about" */  '@/components/toBankhome')
const banktest = () => import(/* webpackChunkName: "about" */  '@/components/banktest')
const sharetest = () => import(/* webpackChunkName: "about" */  '@/components/sharetest')
const agentIntroduce = () => import(/* webpackChunkName: "about" */  '@/components/about/agentIntroduce')

// 中介公司店铺、经纪人空间
const shop = () => import(/* webpackChunkName: "shop" */ '@/components/shop/shop')
const agency = () => import(/* webpackChunkName: "shop" */ '@/components/shop/agency')
//物业系统相关
const propertyFee = () => import(/* webpackChunkName: "shop" */ '@/components/propertysys/propertyFee')
const orderPay = () => import(/* webpackChunkName: "shop" */ '@/components/propertysys/orderPay')
const orderPaySuccess = () => import(/* webpackChunkName: "shop" */ '@/components/propertysys/orderPaySuccess')
const repair = () => import(/* webpackChunkName: "shop" */ '@/components/propertysys/repair')

//行情
const pointPrice = () => import(/* webpackChunkName: "price" */ '@/components/pointPrice')

//Vue.use(VueRouter)
var sysName=store.getters.getSourceSwitch('sysName');
var oauthTitle=sysName?sysName:'房产管家';
var strobeTitle=oauthTitle;
var houseTitle=oauthTitle;
var router = new VueRouter({
  mode: 'history',
  //mode: 'hash',
  routes: [
    // 地图页
    // {
    //   path: '/map',
    //   name: 'Map',
    //   component: Maps,
    //   meta: {
    //     title: '房产评估'
    //   }
    // },
    {
      // 授权中转页
      path: '/oauth',
      name: 'Oauth',
      component: Oauth,
      meta: {
        title: oauthTitle
      }
    },
    {
      // 授权中转页
      path: '/OauthThirdpart',
      name: 'OauthThirdpart',
      component: OauthThirdpart,
      meta: {
        title: '城市房产第三方平台授权'
      }
    }, {
      // 授权中转页
      path: '/strobe',
        name: 'Strobe',
        component: Strobe,
        meta: {
          title: strobeTitle
        }
    },{
      // 首页-微信公众号
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        title: houseTitle
      },
    },{
      // 首页-添加关注小区
      path: '/followHaAdd',
      name: 'followHaAdd',
      component: followHaAdd,
      meta: {
        title: '添加小区'
      },
    },{
      // 首页-添加关注小区
      path: '/followHa',
      name: 'followHa',
      component: followHa,
      meta: {
        title: '我的小区列表'
      },
    },{
      // 我的房产
      path: '/house/',
      name: 'MyHouse',
      component: MyHouse,
      meta: {
        title: houseTitle
      },
    }
    ,{
      // ceshi
      path: '/testgeo',
      name: 'testgeo',
      component: testgeo,
      meta: {
        title: houseTitle
      },
    }
    ,{
      // 我的房产
      path: '/pointPrice/',
      name: 'pointPrice',
      component: pointPrice,
      meta: {
        title: '房价模块'
      },
    }
    ,{
      // 房产详细
      path: '/house/detail/:id',
      name: 'HouseDetail',
      component: HouseDetail,
      meta: {
        title: '房产详情',
        scrollToTop: true,
        needLogin:true
      },
    },
    {
      // 贷款申请
      path: '/loan/apply/:suitcode',
      name: 'loanApply',
      component: loanApply,
      meta: {
        title: '贷款申请',
        scrollToTop: true,
        needLogin:true
      },
    },
    {
      // 贷款记录
      path: '/loan/credit/:suitcode',
      name: 'creditRegistry',
      component: creditRegistry,
      meta: {
        title: '贷款记录',
        needLogin:true
      },
    },
    {
      // 贷款状态
      path: '/loan/status/:loanCode/:suitCode/:applyTime',
      name: 'loanStatus',
      component: loanStatus,
      meta: {
        title: '贷款状态',
        needLogin:true
      },
    },
    {
      // 估价异议反馈
      path: '/house/objectionList/:suitCode/:saleOrLease',
      name: 'ObjectionList',
      component: ObjectionList,
      meta: {
        title: '估价异议反馈',
        scrollToTop: true
      },
    },
    {
      // 小区详细
      path: '/ha/detail/:city/:id',
      name: 'HaDetail',
      component: HaDetail,
      meta: {
        title: '小区详情',
        scrollToTop: true
      },
    },
    {
      // 配套详细
      path: '/ha/support/:city/:id',
      name: 'HaSupport',
      component: HaSupport,
      meta: {
        title: '配套详情',
        scrollToTop: true
      },
    },
    {
      // 补充信息
      path: '/ha/addhainfo/:city/:hacode',
      name: 'addHaInfo',
      component: addHaInfo,
      meta: {
        title: '补充小区信息',
        needLogin:true
      },
    },
    {
      // 小区周边
      path: '/ha/around/:id',
      name: 'HaAround',
      component: HaAround,
      meta: {
        title: '位置与周边'
      },
    },
    {
      // 新楼盘小区
      path: '/ha/:city?/:dist?',
      name: 'Ha',
      component: Ha,
      meta: {
        title: '新楼盘',
        scrollToTop: true,
        keepAlive: true
      },
    },
    {
      // 地图找房
      path: '/map/asset',
      name: 'MapAsset',
      component: MapAsset,
      meta: {
        title: '地图找房',
        keepAlive: true
      },
    },{
      // 地图找房2
      path: '/map/asset2',
      name: 'MapAsset2',
      component: MapAsset2,
      meta: {
        title: '地图找房',
        keepAlive: true
      },
    },
    {
      // 添加房产
      path: '/house/add',
      name: 'HouseAdd',
      component: HouseAdd,
      meta: {
        title: '录入房产信息'
      }
     },
     {
       // 编辑房产房产
       path: '/house/edit/:suitCode',
       name: 'HouseEdit',
       component: (resolve)=>require(['@/components/HouseEdit'],resolve),
       meta: {
         title: '编辑房产信息'
       }
      },
     {
      // 添加房产
      path: '/ad/coSolution',
      name: 'coSolution',
      component: coSolution,
      meta: {
        title: '“年”来了，邀请小福猪来我家！'
      }
    },{
      // 添加房产
      path: '/ad/pighouse',
      name: 'pighouseShow',
      component: pighouseShow,
      meta: {
        title: '“年”来了，邀请小福猪来我家！'
      }
    }, {
      // 添加房产
      path: '/ad/pighouseadd',
      name: 'pighouseAdd',
      component: pighouseAdd,
      meta: {
        title: '“年”来了，邀请小福猪来我家！'
      }
    }, {
      // 添加房产
      path: '/ad/pighouseresult',
      name: 'pighouseResult',
      component: pighouseResult,
      meta: {
        title: '“年”来了，邀请小福猪来我家！'
      }
    }, {
      // 评估结果分享页
      path: '/about/job',
      name: 'job',
      component: Job,
      meta: {
        title: '禧泰数据 （青岛&北京）'
      }
    }, {
      // 添加房产
      path: '/house/map',
      name: 'HouseMap',
      component: HouseMap,
      meta: {
        title: '地图'
      }
    }, {
      // 房产评估结果
      path: '/house/evaluate/:id',
      name: 'HouseEvaluate',
      component: HouseEvaluate,
      meta: {
        title: '评估结果'
      }
    }
    //, {
    //  // 房产评估结果
    //  path: '/house/evaluatetest/:id',
    //  name: 'HouseEvaluatetest',
    //  component: HouseEvaluatetest,
    //  meta: {
    //    title: '评估结果'
    //  }
    //}
    , {
      // 评估历史
      path: '/house/history/:id',
      name: 'AssessHistory',
      component: AssessHistory,
      meta: {
        title: '评估历史'
      }
    },
    {
      // 评估记录
      path: '/house/record',
      name: 'AssessRecord',
      component: AssessRecord,
      meta: {
        title: '评估记录'
      }
    },
    {
      path: '/house/setAlarm/:id',
      name: 'SetAlarm',
      component: SetAlarm,
      meta: {
        title: '房价预警'
      }
    },
    {
      /*选房列表*/
      path: '/selecthouse',
      name: 'selectHouse',
      component: selectHouse,
      meta: {
        title: '选房列表',
        keepAlive: true
      }
    },
    {
      /*选房列表商铺办公*/
      path: '/shopoffice',
      name: 'selectHouseShopOffice',
      component: selectHouseShopOffice,
      meta: {
        title: '商铺办公',
        keepAlive: true
      }
    },
    {
      /*选房列表商铺办公*/
      path: '/apartment',
      name: 'apartment',
      component: apartment,
      meta: {
        title: '商铺办公',
        keepAlive: true
      }
    },
    {
      /*房源置换列表*/
      path: '/house/trade/list',
      name: 'tradeList',
      component: tradeList,
      meta: {
        title: '房源置换列表',
        keepAlive: true
      }
    },
    {
      /*房源详细页*/
      path: '/trade/detail/:city/:id/:flag',
      name: 'tradeDetail',
      component: tradeDetail,
      meta: {
        title: '房源详细页'
      }
    },
    {
      /*同小区房源页面*/
      path: '/trade/comunity/:city/:haCode/:propType/:saleOrLease',
      name: 'tradeComunity',
      component: tradeComunity,
      meta: {
        title: '同小区房源'
      }
    },
    {
      /*同小区房源页面*/
      path: '/trade/comunitygy/:city/:haCode',
      name: 'tradeApartment',
      component: tradeApartment,
      meta: {
        title: '户型'
      }
    },
    {
      /*房源举报页面*/
      path: '/trade/report/:city/:saleOrLease/:dealCode/:label',
      name: 'tradeReport',
      component: tradeReport,
      meta: {
        title: '举报房源',
        needLogin:true
      }
    },
    {
      /*房源发布*/
      path: '/house/release/:suitCode/:saleOrLease',
      name: 'release',
      component: release,
      meta: {
        title: '房源发布'
      }
    },
    {
      /*房源发布*/
      path: '/house/editRelease/:city/:dealCode/:saleOrLease',
      name: 'editRelease',
      component: editRelease,
      meta: {
        title: '编辑房源'
      }
    },
    {
      // 个人中心
      path: '/manage',
      name: 'manage',
      component: Manage,
      meta: {
        title: '个人中心'
      }
    },{
      // 账号信息
      path: '/account',
      name: 'account',
      component: Account,
      meta: {
        title: '账号信息'
      }
    },{
      // 账号信息
      path: '/protocol',
      name: 'protocol',
      component: protocol,
      meta: {
        title: '用户协议'
      }
    },
    {
      // 我关注的小区
      path: '/manage/ha',
      name: 'manageHa',
      component: ManageHa,
      meta: {
        title: '我关注的小区',
        needLogin:true
      }
    },
    {
      // 我收藏的房源
      path: '/manage/house',
      name: 'manageHouse',
      component: ManageHouse,
      meta: {
        title: '我收藏的房源',
        needLogin:true
      }
    },
    {
      // 编辑个人资料
      path: '/manage/:mode',
      name: 'manageInfo',
      component: ManageInfo,
      meta: {
        title: '个人资料编辑',
        needLogin:true
      }
    },
    {
      // 跳转工行房产管家公众号首页
      path: '/tobankhome',
      name: 'toBankhome',
      component: toBankhome,
      meta: {
        title: '房产管家首页'
      }
    },
    {
      // 跳转中介页
      path: '/toPage',
      name: 'toPage',
      component: toPage,
      meta: {
        title: '跳转'
      }
    },
    {
      // 跳转工行房产管家公众号首页
      path: '/banktest',
          name: 'banktest',
        component: banktest,
        meta: {
        title: '房产管家首页'
        }
    }
    ,
    {
      // 跳转工行房产管家公众号首页
      path: '/sharetest',
          name: 'sharetest',
        component: sharetest,
        meta: {
          title: '房产管家首页'
        }
    },
    {
      // 房产中介介绍
      path: '/about/agentIntroduce',
      name: 'agentIntroduce',
      component: agentIntroduce,
      meta: {
        title: '房产中介介绍'
      }
    },
    {
      // 中介公司店铺
      path: '/shop/:city/:coCode',
      name: 'shopSpace',
      component: shop,
      meta: {
        title: '社区中介公司店铺'
      }
    },
    {
      // 经纪人空间
      path: '/agency/:city/:userUid',
      name: 'agencySpace',
      component: agency,
      meta: {
        title: '经纪人空间'
      }
    },
    {
      // 物业缴费列表
      path: '/propertyFee',
      name: 'propertyFee',
      component: propertyFee,
      meta: {
        title: '物业缴费列表',
        needLogin:true
      }
    },
    {
      // 物业缴费-账单支付
      path: '/orderPay',
      name: 'orderPay',
      component: orderPay,
      meta: {
        title: '物业缴费-账单支付',
        needLogin:true
      }
    },
    {
      // 物业缴费-账单支付成功
      path: '/orderPaySuccess',
      name: 'orderPaySuccess',
      component: orderPaySuccess,
      meta: {
        title: '物业缴费-账单支付成功',
        needLogin:true
      }
    },
    {
      // 物业报修
      path: '/property/repair',
      name: 'repair',
      component: repair,
      meta: {
        title: '物业报修',
        needLogin:true
      }
    },
    {
      // 住在青岛
      path: '/livingIndex',
      name: 'livingIndex',
      component: livingIndex,
      meta: {
        title: '住在',
        needLogin:true
      }
    }
  ]
});

// 不同页面title展示，兼容处理ios微信
//document.setTitle = function (t) {
//  document.title = t;
//  /*城市房产android 客户端 交互*/
//  let channels = ['cityhouse.mobile.android','creprice.mobile.android','cityhouse.mobile.ios','creprice.mobile.ios'];
//  if (channels.indexOf(store.getters.getChannel)>-1) {
//    try{
//      window.action.detail(t);
//    }catch(e){
//      console.log(e)
//    }
//  }
//}




router.beforeEach((to, from, next) => {
  //选房页面首次进入清除keepAlive缓存=========================================================================
  //if(to.name=='selectHouse'&&to.name==from.name){
  //  to.meta.keepAlive=false;
  //}else if(from.name=='selectHouse'&&to.name!=from.name){
  //  from.meta.keepAlive=true;
  //}
  if(window._axiosPromiseArr)window._axiosPromiseArr.forEach((ele,index) => {
    ele() // 路由跳转之前，清空（终止）上一个页面正在请求的内容
    // 清空请求的参数 清空请求的参数
    delete window._axiosPromiseArr[index]
  })
  // 百度统计PV=============================================================================================
  if (to.path) {
     store.getters.statistics(to.path);
  }
  //如果是房产管家app且是登录页面
  if(to.name == "Oauth" && store.getters.getSourceSwitch('use_in_fcgj_app') && typeof(to.query.from_fcgj_app)=="undefined"){
    window.location.href = "xt://oauth?from=" + encodeURIComponent(location.href)
    return false
  }

  //城市房产app设置title=====================================================================================
  if (to.meta.title){
    setTitle.set(store,to.meta.title,to);
  }
  //单独设置民生银行返回按钮==================================================================================
  //if(store.getters.getRealChannel(false)=='cmbc.mobile.app'){
  //  setTitleBar({
  //    "title": to.meta.title, // 标题名
  //    "leftButton": { // 左按钮
  //      "exist": "true", // true:显示左按钮,false:也显示左按钮,客户端不调用左按钮的返回事件
  //      "name": "返回", //  按钮的说明
  //      "func": "goBackToHistory()"
  //    },
  //    "rightButton": {
  //      "exist": "false" // 不显示右按钮dfff
  //    }
  //  });
  //}
  //检查KeepAliveState设置的需要清理缓存的页面=================================================================
  if(from.name&&window.KeepAliveNeedClear){//首次进入系统除外
    window.KeepAliveNeedClear.forEach(function(v,k){
        if(to.name== v.page){//进入目标页面判断是否需要清理
            to.meta.keepAlive=false;
            console.log('关闭keep')
        }
        if(from.name==v.page){//离开后重置
          from.meta.keepAlive=true;
          Util.setState({page:"tradeList"},2);
          console.log('打开keep')
        }
    })
  }
  //=======================================================================================================
  let LastUpdateUserInfoTime=window.localStorage.getItem('LastUpdateUserInfoTime');
  let limitnum=Util.ENV()==1?259200:180000;
  let userInfo=store.getters.getUserInfo();
  let needFrash=LastUpdateUserInfoTime&&(new Date().getTime()-parseInt(LastUpdateUserInfoTime))>=limitnum?true:false;
  if(needFrash){//登录成功后（userInfo.unionUid不为空）如果超过规定时间刷新user接口以延长登录过期时间
      store.dispatch('updateUserInfo').then((e)=>{
        console.log('刷新用户信息');
        userInfo=store.getters.getUserInfo();
        if(to.meta.needLogin&&(!userInfo||!userInfo.unionUid)){
          router.push({name: 'Oauth',query: {state: store.getters.getChannel,to:encodeURIComponent(location.href)}});
        }
        next()
      });
  }else{
    next()
  }



});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js